import React from "react";
import { LowerPictureDiv } from "./style";
import hero from "../../../assets/images/hero.jpg";
import { BsArrowRight } from "react-icons/bs";

function LowerPicture() {
  return (
    <LowerPictureDiv className="col-md-6">
      <img src={hero} />
      <h4>200 doctors that discovered Covid 19 vaccines </h4>
      <p>
        Lorem ipsum dolor sit amet consectetur. <br />
        Commodi a ut odio vel, error iusto assumenda quisquam ipsam <br />
      </p>

      <a href="">
        <p>
          Read more <BsArrowRight />
        </p>
      </a>
    </LowerPictureDiv>
  );
}

export default LowerPicture;
